import React from 'react';
import { CheckIcon, FlameIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const bundle = [{
  emoji: '🤖',
  label: 'MakerLab — 100+ Roboter-Projekte',
  value: '47,00 €'
}, {
  emoji: '🎥',
  label: 'Bonus #1: Cardboard Arcade Pack',
  value: '25,00 €'
}, {
  emoji: '✂️',
  label: 'Bonus #2: Der 5-Minuten-Papercraft-Guide',
  value: '19,00 €'
}, {
  emoji: '🌈',
  label: 'Bonus #3: Kleine Kreative: Slime & Sensorik',
  value: '19,00 €'
}];
export function Offer() {
  return <section id="angebot" className="w-full bg-cream py-16 sm:py-24" data-id="element-120" data-mp="13y2hlv64w2j9">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-121" data-mp="yy7rhtu6ngz9">
        <SectionHeading eyebrow="✦ Alles, was du heute bekommst" title={<>Das komplette MakerLab-Paket</>} data-id="element-122" data-mp="ywd7qiunduwr" />

        <div className="mt-12 overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-xl" data-id="element-123" data-mp="2ad3crync4gos">
          <ul className="divide-y divide-ink/10" data-id="element-124" data-mp="pkh7hdqa50h9">
            {bundle.map(item => <li key={item.label} className="flex items-center justify-between gap-4 px-6 py-4" data-id="element-125" data-mp="ujbny90rycy7">
                <span className="flex items-center gap-3 text-sm font-semibold text-ink" data-id="element-126" data-mp="zjg7k7wzbnsn">
                  <span className="text-xl" aria-hidden="true" data-id="element-127" data-mp="13k9rkq7awig9">
                    {item.emoji}
                  </span>
                  {item.label}
                </span>
                <span className="flex-none text-sm font-medium text-ink/40 line-through" data-id="element-128" data-mp="bskhpgc332o1">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="space-y-2 bg-ink px-6 py-8 text-center text-white" data-id="element-129" data-mp="kl49pxxve8zw">
            <p className="text-sm text-white/60" data-id="element-130" data-mp="kn8nr8phgodw">
              Gesamtwert <span className="line-through" data-id="element-131" data-mp="3k7ugofkofrrl">110,00 €</span>
            </p>
            <p className="flex items-center justify-center gap-2 text-sm font-semibold uppercase tracking-wide text-brand" data-id="element-132" data-mp="3o9pe38zhll03">
              <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="vefsw15ns30k" />
              Du zahlst heute nur
            </p>
            <p className="font-display text-5xl font-black" data-id="element-134" data-mp="qg4gpjrw5gf6">27,00 €</p>
            <p className="text-sm font-semibold text-emerald-400" data-id="element-135" data-mp="154ijxvt7z6w9">
              🎉 Du sparst heute 83,00 €
            </p>

            <div className="pt-4" data-id="element-136" data-mp="106z62x0fow4u">
              <CtaButton className="w-full sm:w-auto" data-id="element-137" data-mp="cgv40u2w94fy">
                Ja! Ich will alles für nur 27 €
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-col items-center gap-2 text-sm text-white/70 sm:flex-row sm:justify-center sm:gap-6" data-id="element-138" data-mp="7j3ci165vkca">
              {['Sofortiger digitaler Zugriff', 'Alle 3 Boni enthalten', 'Einmalzahlung, kein Abo'].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-139" data-mp="1wv5594el6wbq">
                  <CheckIcon className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-140" data-mp="1svwco2va94hr" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm text-ink/50" data-id="element-141" data-mp="25f1ohqwu8mk9">
          <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="1qi111zlojdrl" />
          Sofortiger Zugriff nach dem Kauf · +40.938 Downloads
        </p>
      </div>
    </section>;
}